import React, { createContext, useContext } from "react";

const ReportContext = createContext();

export const useReport = () => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error("useReport must be used within a ReportProvider");
  }
  return context;
};

export const ReportProvider = ({ children, reportData }) => {
  const value = {
    eventMode: reportData?.metadata?.event_mode,
    metadata: reportData?.metadata,
    summary: reportData?.summary,
    participationDetails: reportData?.participation_details?.[0],
    gradewiseData: reportData?.gradewise_data,
    fullReportData: reportData,
  };

  return (
    <ReportContext.Provider value={value}>{children}</ReportContext.Provider>
  );
};
